import Image from "next/image";
import { FC } from "react";

// TODO: buscar dinamicamente o logo

const AppHeader: FC = () => {
  return (
    <>
      <header className="sticky top-0 z-50 w-full border-b bg-background/95 supports-[backdrop-filter]:bg-background/60 backdrop-blur  py-1 p-5 ">
        <div className="flex py-3">
          <Image
            src="/amcham.png"
            height={100}
            width={200}
            alt="Partner logo"
            layout="fixed"
            className=""
          />
        </div>
      </header>
    </>
  );
};

export default AppHeader;
